import { HorSpacerSm, VertSpacerMd, VertSpacerSm } from '@apps-common/components/layout'

export const ProductCardSkeleton = () => (
  <div className='w-full p-6 bg-skeleton rounded-3xl border border-border'>
    <div className='w-full animate-pulse'>
      <div className='flex items-center justify-end gap-[5px]'>
        <div className='avatar'>
          <div className='!flex w-7 items-center justify-center rounded-full bg-skeleton-hi' />
        </div>
        <div className='avatar'>
          <div className='!flex w-7 items-center justify-center rounded-full bg-skeleton-hi' />
        </div>
      </div>
      <div className='flex items-center'>
        <div className='avatar'>
          <div className='!flex w-9 items-center justify-center rounded-full bg-skeleton-hi' />
        </div>
        <HorSpacerSm />
        <div className='bg-skeleton-hi w-[20%] h-[20px] rounded-[10px]' />
      </div>
      <VertSpacerMd />
      <div className='bg-skeleton-hi w-[50%] h-[15px] rounded-[10px]' />
      <VertSpacerMd />
      <div className='bg-skeleton-hi w-[80%] h-[15px] rounded-[10px]' />
      <VertSpacerSm />
      <div className='bg-skeleton-hi w-[100%] h-[15px] rounded-[10px]' />
      <VertSpacerSm />
      <div className='bg-skeleton-hi w-[100%] h-[15px] rounded-[10px]' />
    </div>
  </div>
)
